<template>
  <div class="app-docs-filter relative">
    <input
      ref="filterRef"
      :value="modelValue"
      class="app-docs-filter-input"
      :placeholder="placeholder"
      @input="onInput"
    />
    <GfrNewButton class="app-docs-filter-btn group" :data-state="trigger ? 'active' : 'none'" @click="handleFilterBtn">
      <IconsFilter class="h-6 w-6 group-data-[state=active]:hidden" />
      <IconsClear class="h-6 w-6 group-data-[state=none]:hidden" />
    </GfrNewButton>
  </div>
</template>
<script lang="ts" setup>
const filterRef = ref<HTMLElement>()
const props = defineProps({
  modelValue: { type: String, default: '' },
  placeholder: { type: String, default: 'Filter by title' },
  trigger: { type: Boolean, default: false }
})
const emit = defineEmits(['update:modelValue', 'clear', 'update:trigger'])
function onInput(e: any) {
  onUpdate(e.target.value)
  if (props.trigger) {
    emit('update:trigger', false)
  }
}
function onTrigger() {
  emit('update:trigger', true)
}
function onUpdate(value: string) {
  emit('update:modelValue', value)
}
function onClear() {
  emit('clear')
  emit('update:modelValue', '')
  emit('update:trigger', false)
}
function handleFilterBtn() {
  if (props.trigger) {
    onClear()
  } else if (props.modelValue.trim()) {
    onTrigger()
  }
}
// 触发式数据绑定
onMounted(() => {
  if (filterRef.value) {
    filterRef.value?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        onTrigger()
      }
    })
  }
})
</script>
<style lang="scss" scoped>
.app-docs-filter-input {
  @apply h-8 w-full rounded-none border border-solid border-[#999]/25 bg-dark-background py-1 text-sm leading-6 text-white transition-colors duration-300 placeholder:text-[#707070] focus:border-primary;
  @apply ltr:pl-3 ltr:pr-8 ltr:max-lg:pr-14 rtl:pl-8 rtl:pr-3 rtl:max-lg:pl-14;
}
.app-docs-filter-btn {
  @apply absolute top-1/2 -translate-y-1/2 text-[#707070] transition-colors duration-200 hover:text-light;
  @apply ltr:right-2.5 rtl:left-2.5;
}
</style>
